import Card from '../../ui/card/Card';
import { getClassNames } from '../../helpers/classHelpers';
import { isObject } from '@danfoss/mosaic-core';
import { Icons } from '../../ui/icon/icons/material';
import { Starter } from '../../models/types';
import styles from './ChatStarters.module.scss';

const ChatStarters = ({ className, starters, isDisabled, onSubmit, onPrefill }: { className?: string, starters?: Starter[], isDisabled?: boolean, onSubmit: (starter: string) => Promise<void>; onPrefill: (starter: string) => void; }) => {
    if (!starters?.length) return null;
    return (
        <div className={getClassNames([className, styles['chat-starters'], starters.length % 3 === 0 && styles['three-column-layout']])}>
            {starters.map((s, i) => {
                const label = isObject(s) ? s.prompt : s;
                const hasAutoSubmit = typeof s === 'object' && s.autoSubmit;

                return <Card
                    key={i}
                    description={label}
                    className={styles.card}
                    iconClassName={styles.icon}
                    titleClassName={styles.title}
                    isDisabled={isDisabled}
                    icon={{ iconName: hasAutoSubmit ? Icons.send : Icons.keyboardExternalInput, size: 20 }}
                    onClick={() => {
                        if (hasAutoSubmit) onSubmit(label);
                        else onPrefill(label);
                    }}
                />;
            })}
        </div>
    );
};

export default ChatStarters;